import { ON, OFF } from 'consts';
import { isOn } from 'util/index';

export const DEFAULT_DELAY_DAYS = 2;

export default function buildExtDdaRtConfig(rtOffOn, delayDaysRaw) {
  const rtOn = isOn(rtOffOn);
  const delayDays = delayDaysRaw ?? DEFAULT_DELAY_DAYS;
  return {
    featureEnabled: rtOn ? ON : OFF,
    delayDays: rtOn ? delayDays : DEFAULT_DELAY_DAYS,
  };
}
